// extracted by mini-css-extract-plugin
module.exports = {"baseBtnIcon":"BaseIconButton_baseBtnIcon_3jOGY"};